export function googleAnalyticsEvent (category, eventAction) {

  // @ts-ignore
  if( typeof gtag !== 'function' ){
    return false;
  }
  // @ts-ignore
  gtag('event', eventAction, {
    'category': category
  });

}

export default googleAnalyticsEvent
